import React, { Component } from "react";
import * as router from "react-router-redux";
import { connect } from "react-redux";
import { actions } from "./redux";
import CSSModules from "react-css-modules";
import Highcharts from "highcharts";
import ReactHighcharts from "react-highcharts";
import ToggleChartSeries from '../../../ToggleChartSeries/ToggleChartSeries';

import styles from "./styles.scss";

@CSSModules(styles, { allowMultiple: true })
class PercentageOutsideRangeChart extends Component {
	constructor(props) {
		super(props);
		this.chart = React.createRef();
	}

	render() {
		const config = {
			chart: {
				animation: false,
				zoomType: "x",
				panning: true,
				panKey: "shift",
				style: {
					fontFamily: "Helvetica"
				}
			},
			credits: {
				enabled: false
			},
			colors: ["#349EB3", "#536BAD"],
			title: {
				text: this.props.component.chartTitle || "Percentage of Samples outside of Range",
				align: "left",
				margin: 60,
				style: {
					color: "#4D4D4D",
					"font-size": "20px",
					"font-weight": "600"
				}
			},
			legend: {
				enabled: false
			},
			tooltip: {
				enabled: false
			},
			xAxis: {
				type: "category",
				labels: {
					autoRotationLimit: 1000,
					y: 30,
					style: {
						fontSize: "14px",
						color: "#999"
					}
				},
				tickWidth: 0,
				lineColor: "#e6e6e6"
			},
			yAxis: {
				title: {
					text: "%",
					align: "high",
					rotation: 0,
					margin: 0,
					y: -30,
					offset: 14,
					style: {
						"font-weight": "600",
						"font-size": "15px",
						"font-family": "Helvetica"
					}
				},
				labels: {
					style: {
						fontSize: "14px",
						color: "#999"
					}
				}
			},
			series: []
		};
		return (
            <div>
                <ReactHighcharts config={config} ref={this.chart} isPureConfig={true} />
                <ToggleChartSeries chart={this.chart} />
            </div>
        ) 
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (nextProps.timePeriod !== this.props.timePeriod) {
			let chart = this.chart.current.getChart();
			this.props.loadData(this.props.component, chart, this.props.timePeriod);
			setTimeout(() => {
			   if(chart) {
				  chart.reflow();
				  chart.redraw();
			   }
			}, 100);
			return true;
		}else{
			return nextProps.component !== this.props.component
		}
	}

	setup() {
		let chart = this.chart.current.getChart();
		this.props.loadData(this.props.component, chart, this.props.timePeriod, this.props.onLoadComplete);
		setTimeout(() => {
		   if(chart) {
			  chart.reflow();
			  chart.redraw();
		   }
		}, 100);
	}

	teardown() {}

	componentDidMount() {
		this.setup();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		this.setup();
	}
}

const bindAction = dispatch => {
	return {
		loadData: (component, chart, timePeriod, onLoadComplete) => dispatch(actions.loadData(component, chart, timePeriod, onLoadComplete))
	};
};

const mapStateToProps = (state, ownProps) => ({});

export default connect(
	mapStateToProps,
	bindAction
)(PercentageOutsideRangeChart);



// WEBPACK FOOTER //
// ./src/components/ReportComponents/Charts/PercentageOutsideRangeChart/PercentageOutsideRangeChart.js